/* eslint-disable no-fallthrough */
import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import moment from "moment";

import { setLoading } from "../../helpers/redux";
import Loading from "../../common/components/ui/loadingPrint/loadingPrint";
import { API_STATIC } from "../../config/consts";

import LogoHorizontal from "../../assets/images/logo-horizontal.png";

import { getListFiltered as getMyCharts } from "../../modules/system/pages/myCharts/myChartsActions.js";
import types from "../../modules/system/pages/home/homeTypes";
import { chartToPrint } from "../../modules/system/pages/home/homeActions";

import { PDFExport } from "@progress/kendo-react-pdf";
import { dateFormat2Show } from "../../helpers/dataTransformers";
import Button from "../../common/components/ui/button/button";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { defineFont } from '@progress/kendo-drawing/pdf';

defineFont({
    "morinus-webfont"         : "../../assets/fonts/morinus-webfont.ttf",
    "DejaVu Sans"             : "http://cdn.kendostatic.com/2014.3.1314/styles/fonts/DejaVu/DejaVuSans.ttf",
    "DejaVu Sans|Bold"        : "http://cdn.kendostatic.com/2014.3.1314/styles/fonts/DejaVu/DejaVuSans-Bold.ttf",
    "DejaVu Sans|Bold|Italic" : "http://cdn.kendostatic.com/2014.3.1314/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf",
    "DejaVu Sans|Italic"      : "http://cdn.kendostatic.com/2014.3.1314/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf"
})

class PrintPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            print: false
        };
        this.props.setLoading(types.HOME_PRINT_LOADING, true);
       
    }

    // renderHouses = () => {
    //     const houseList = this.props.home.chartToPrint.chartData.houses.map(item => (
    //         <li className="print__table">
    //             <span style={{ flexDirection: "row" }}>
    //                 <span>{item.number} - </span>
    //                 <span>0 </span>
    //                 <b className={`morinus-${item.sign.toLowerCase()}`} />
    //                 <span> 29</span>
    //             </span>
    //         </li>
    //     ));
    //     return houseList;
    // };

    componentDidMount() {
        if (_.isUndefined(this.props.home.chartToPrint.chart) || _.isUndefined(this.resume)) {
            this.props.router.push("/");
        // } else if (this.props.home.chartToPrint.chartType !== "transito") {
        } else {
            setTimeout(() => {
                this.exportPDF();
            }, 800);
        }
    }

    renderTableTransits = data => {
        const months = {
            "01": [],
            "02": [],
            "03": [],
            "04": [],
            "05": [],
            "06": [],
            "07": [],
            "08": [],
            "09": [],
            "10": [],
            "11": [],
            "12": []
        };
        for (const i in data) {
            if (!_.isUndefined(data[i].day)) {
                months[data[i].day.substr(5, 2)].push(data[i]);
            }
        }

        let monthArray = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
        return <div className="print-all" style={{marginTop: "4rem"}}>{this.renderMonths(months, monthArray)}</div>;
    };

    renderMonths = (data, months) => {
        let listItems = [];
        for (const i in months) {
            if (data[months[i]].length > 0) {
                const monthList = data[months[i]].map(item => (
                    <li className="print__transits--day">
                        <span style={{ flexDirection: "row" }}>
                            <span>{item.day.substr(8, 2)} - </span>
                            <b className={`morinus-${item.planet1.toLowerCase()}`} />
                            <b className={`morinus-${item.planet1_sign.toLowerCase()}`} />
                            <b className={`morinus-${item.transit.toLowerCase()}`} />
                            <b className={`morinus-${item.planet2.toLowerCase()}`} />
                            <b className={`morinus-${item.planet2_sign.toLowerCase()}`} />
                        </span>
                    </li>
                ));
                const nameMonth = moment(months[i], "MM").format("MMMM");
                const month = (
                    <div className="transits__month transits__month-expanded print__transits-final">
                        <h2 className={"print__transits--title"}>
                            {nameMonth}
                        </h2>
                        <ul 
                            className="print__transits--body" 
                            style={(i === '0' || i === '1') ? {height:  "114mm"} : {height: "89mm"}}>
                        
                            {monthList}
                        </ul>
                    </div>
                );
                listItems = listItems.concat(month);
            }
        }
        return listItems;
    };

    convertCordinates = (lat, lon) => {
        let latConv = "",
            lonConv = "";
        if (lat.substr(0, 1) === "-") {
            latConv = `${lat.substr(1, 2)}°${lat.substr(4, 2)}' S`;
        } else {
            latConv = `${lat.substr(0, 2)}°${lat.substr(3, 2)}' N`;
        }
        if (lon.substr(0, 1) === "-") {
            lonConv = `${lon.substr(1, 2)}°${lon.substr(4, 2)}' W`;
        } else {
            lonConv = `${lon.substr(0, 2)}°${lon.substr(3, 2)}' E`;
        }

        return `${latConv} ${lonConv}`;
    };

    generatePDF = (callback) => {
        const { chart } = this.props.home.chartToPrint;

        html2canvas(document.getElementById('print'),{scale: '2'}).then(function(canvas) {
    
          var imgData = canvas.toDataURL('image/JPEG');
    
          /*
          Here are the numbers (paper width and height) that I found to work. 
          It still creates a little overlap part between the pages, but good enough for me.
          if you can find an official number from jsPDF, use them.
          */
          var imgWidth = 210; 
          var pageHeight = 295;  
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight;
    
          var doc = new jsPDF('p', 'mm');
          var position = 0;
    
          doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
    
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
    
    
          doc.save( `${chart.images.data.type} de ${chart.data.person_name}.pdf`);
          callback();
        });
      }

    finishedPDF = () => {
        this.props.setLoading(types.HOME_PRINT_LOADING, false);
        
    }  

    exportPDF = () => {
        this.props.setLoading(types.HOME_PRINT_LOADING, true);

        if (this.props.home.chartToPrint.chartType!=='transito') {
            this.resume.save();
        this.props.setLoading(types.HOME_PRINT_LOADING, false);

        } else {
           this.generatePDF(this.finishedPDF)
        }
    };

    backToMain = () => {
        this.props.router.push('/')
    }

    renderSubtitle = () => {
        const { chart, chartType } = this.props.home.chartToPrint;
        if( chartType === "solar" || chartType === "lunar") {
            return (
                <h3  className="title-10" style={{textAlign: 'center'}}>
                    {chart.data.returnCity.name}, {chart.data.returnCity.state ? chart.data.returnCity.state.name : ''} - {chart.data.returnCity.country_letters} {this.convertCordinates(chart.data.returnCity.lat,chart.data.returnCity.lon)} UTC {parseInt(chart.data.returnCity.timezone)} <br/> {dateFormat2Show(chart.images.dateReturn.date, '/')} {chart.images.dateReturn.hour}
                </h3>
            );
        } else {
            return null;
        }
    }


    render() {

        const { chart, chartType } = this.props.home.chartToPrint;
        if (this.props.home.chartToPrint==='') {
            this.backToMain();
            return null;
        }
        return (
            <React.Fragment>
                
                <div className="backPrint">
                    
                    <div className="form__footer--actions" style={{justifyContent: 'space-between', display: 'flex'}}>
                        <Button
                            text="Voltar"
                            type="button"
                            style={{marginTop:'1rem'}}
                            rounded
                            colors={"#113950"}
                            textStyle={{ color: "#555" }}
                            outline
                            onClick={this.backToMain}
                        />
                        <Button
                            text="Download"
                            type="button"
                            style={{marginTop:'1rem'}}
                            rounded
                            colors={"#113950"}
                            textStyle={{ color: "#555" }}
                            outline
                            onClick={this.exportPDF}
                        />
                    </div>
                    <PDFExport
                        paperSize={"Letter"}
                        // margin={chartType === "transito" ? "0.5cm" : null}
                        forcePageBreak=".page-break"
                        fileName={`${chart.images.data.type} de ${chart.data.person_name}.pdf`}
                        title={`${chart.images.data.type} de ${chart.data.person_name}.pdf`}
                        subject=""
                        keywords=""
                        ref={r => (this.resume = r)}
                    >
                        <div className="print" id="print" style={chartType === 'transito' ? { width: '210mm', minHeight: '297mm', marginLeft: 'auto', marginRight: 'auto'}:undefined}>
                            <img src={LogoHorizontal} className="print__body--logo" alt="Logo" />
                            <div className="print__body">
                                <h3 style={{fontWeight: 'bold'}}>{chart.data.person_name}</h3>
                                <h3>{chart.data.name}</h3>
                                <h3>
                                    {dateFormat2Show(chart.data.birthday, "/")} {chart.data.hour}
                                </h3>
                                <h3 >
                                    {chart.birth.city.name}, {chart.birth.city.state ? chart.birth.city.state.name : '' } - {chart.birth.city.country_letters}
                                </h3>
                                <h3>
                                    {this.convertCordinates(chart.birth.city.lat, chart.birth.city.lon)} UTC{" "}
                                    {parseInt(chart.birth.city.timezone)}
                                </h3>
                            </div>
                            <div
                                style={{ width: "100%", padding: "0 1rem", marginTop: "11rem" }}>
                                <h3 className="title-15" style={{ textAlign: "center" }}>
                                    {chart.images.data.type}
                                </h3>
                                {chartType !== "natal" ? (
                                    <div>
                                         {this.renderSubtitle()}
                                    </div>
                                ) : null}
                            </div>
                            {chartType === "transito" ? (
                                this.renderTableTransits(chart.images)
                            ) : (
                                <div style={{marginTop: "3rem"}}>
                                    <img
                                        className="home__chart1--content-chart home__chart1--content-chart-expanded print__body--img"
                                        src={`${API_STATIC}/${chart.images.chart}`}
                                        alt="Mapa Astral"
                                    />
                                    <img
                                        className="print__body--aspects"
                                        id="aspects"
                                        src={`${API_STATIC}/${chart.images.aspects}`}
                                        alt="Outros dados do mapa"
                                    />
                                    {/* <div className="print__body--houses">
                                        <ul>{this.renderHouses()}</ul>
                                    </div> */}
                                </div>
                            )}
                            <div className="print__footer">Copyright Francisco Seabra e Pedro Alcântara</div>
                        </div>
                    </PDFExport>
                    
                </div>
                <Loading isVisible={this.props.loading} overlay={true} />

            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
        myCharts: state.myChart,
        home: state.homePage,
        loading: state.homePage.loadingPrint
    };
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(
        {
            chartToPrint,
            getMyCharts,
            setLoading
        },
        dispatch
    )
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PrintPage);
